import { TFunction } from "i18next";

interface Mapping {
    [key: string]: string;
}

export const getAeMapping = (t: TFunction): Mapping => ({
    ae01: "<b>a<sub>e</sub> = 0,1&#10005;D</b>",
    ae02: "<b>a<sub>e</sub> = 0,2&#10005;D</b>",
    ae03: "<b>a<sub>e</sub> = 0,3&#10005;D</b>",
    ae005: "<b>a<sub>e</sub> = 0,05&#10005;D</b>",
    ae06: "<b>a<sub>e</sub> = 0,6&#10005;D</b>",
    ae10: "<b>a<sub>e</sub> = 1,0&#10005;D</b>",
    ae1005: "<b><sub>e</sub> = 1,005&#10005;D</b>",
    aecopy: `<b>${t("cuttingDataMappings.copy")}</b>`, // i18next.t() wird erst zur Laufzeit ausgeführt
});

export const getMaterialGroups = (t: TFunction): Mapping => ({
    p1: "<700",
    p2: "<1000",
    p3: "<1300",
    p4: "",
    m1: "<900",
    m2: ">900",
    k1: ">400",
    k2: ">750",
    n1: t("cuttingDataMappings.long"),
    n2: t("cuttingDataMappings.short"),
    n3: "Cu",
    s1: ">850",
    s2: "Ni",
    h1: "<52 HRC",
    h2: "<60 HRC",
    h3: ">60 HRC",
    c_cfk: "",
    c_gfk: "",
    c_afk: "",
    c_elast: ""
})


export const materialGroupsFormatting = (name: String) => {
    if (name.startsWith("c_")) {
        return name.replace("c_", "")
    }
    return name
}
